import React from "react";
import { SvgIcon } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 36,
    height: 36,
    fill: "transparent"
  }
});

class IcWhiteStar extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    viewBox = { "0 0 36 36" } >
      <path d="M18 3L22.635 12.39L33 13.905L25.5 21.21L27.27 31.53L18 26.655L8.73 31.53L10.5 21.21L3 13.905L13.365 12.39L18 3Z" fill="#C27100" stroke="#C27100" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IcWhiteStar);
